/* Soft & Rooted theme.js */
(function(){
'use strict';
const money=c=>'$'+(c/100).toFixed(2);
const Cart={
  get:()=>fetch('/cart.js').then(r=>r.json()),
  add:id=>fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:1})}).then(r=>r.json()),
  change:(key,q)=>fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(r=>r.json())
};
function toast(msg){const t=document.getElementById('toast');if(!t)return;t.textContent=msg;t.classList.add('show');setTimeout(()=>t.classList.remove('show'),2600);}
const Drawer={
  el:null,
  init(){this.el=document.getElementById('cart-drawer');if(!this.el)return;
    this.el.querySelectorAll('[data-close-cart]').forEach(b=>b.addEventListener('click',()=>this.close()));
    document.addEventListener('keydown',e=>{if(e.key==='Escape')this.close();});},
  async open(){if(!this.el)return;this.el.classList.add('open');this.el.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';await this.render();},
  close(){if(!this.el)return;this.el.classList.remove('open');this.el.setAttribute('aria-hidden','true');document.body.style.overflow='';},
  async render(){const cart=await Cart.get();
    const body=document.getElementById('cart-body');const sub=document.getElementById('cart-subtotal');
    if(sub)sub.textContent=money(cart.total_price);this.count(cart.item_count);
    if(!body)return;
    if(!cart.item_count){body.innerHTML='<p class="drawer__empty">Your cart is empty.</p>';return;}
    body.innerHTML=cart.items.map(i=>`
      <div class="ditem">
        <div class="ditem__img">${i.image?`<img src="${i.image}" alt="" loading="lazy">`:''}</div>
        <div><div class="ditem__t">${i.product_title}</div>
        <div class="ditem__p">${money(i.final_line_price)}</div>
        <button class="ditem__rm" data-key="${i.key}">Remove</button></div>
      </div>`).join('');
    body.querySelectorAll('.ditem__rm').forEach(b=>b.addEventListener('click',async()=>{await Cart.change(b.dataset.key,0);this.render();}));},
  count(n){document.querySelectorAll('.hd__count').forEach(el=>{el.textContent=n;el.style.display=n>0?'flex':'none';});}
};
async function atc(btn){
  const id=btn.dataset.variantId;if(!id)return;
  const orig=btn.textContent;btn.textContent='Adding…';btn.disabled=true;
  try{await Cart.add(id);toast('Added to cart ♡');Drawer.render();setTimeout(()=>Drawer.open(),320);}
  catch(e){toast('Something went wrong');}
  setTimeout(()=>{btn.textContent=orig;btn.disabled=false;},1400);
}
function accordions(){
  document.querySelectorAll('.faq__q').forEach(q=>{
    q.addEventListener('click',()=>{
      const item=q.closest('.faq__item');const a=item.querySelector('.faq__a');
      const open=item.classList.toggle('open');
      a.style.maxHeight=open?a.scrollHeight+'px':'0';
    });
  });
}
function reveals(){
  if(!('IntersectionObserver'in window))return;
  const els=document.querySelectorAll('.pcard,.circle,.tcard,.faq__item,.dl__card');
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:.12});
  els.forEach((el,i)=>{el.classList.add('rv');el.style.transitionDelay=(i%4)*70+'ms';io.observe(el);});
}
function stickyAtc(){
  const bar=document.getElementById('satc');if(!bar)return;
  const trigger=document.querySelector('.pbuy');if(!trigger)return;
  const io=new IntersectionObserver(([e])=>{bar.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0);},{threshold:0});
  io.observe(trigger);
}
function gallery(){
  const main=document.querySelector('.pgal__main img');if(!main)return;
  document.querySelectorAll('.pgal__thumb').forEach(t=>{
    t.addEventListener('click',()=>{
      document.querySelectorAll('.pgal__thumb').forEach(x=>x.classList.remove('active'));
      t.classList.add('active');
      const src=t.querySelector('img')?.src;if(src)main.src=src;
    });
  });
}
function mobileNav(){
  const burger=document.querySelector('.hd__burger');const nav=document.querySelector('.mnav');
  if(!burger||!nav)return;
  burger.addEventListener('click',()=>nav.classList.toggle('open'));
  document.addEventListener('click',e=>{if(!nav.contains(e.target)&&!burger.contains(e.target))nav.classList.remove('open');});
}
function headerShadow(){const hd=document.querySelector('.hd');if(!hd)return;
  addEventListener('scroll',()=>hd.classList.toggle('is-scrolled',scrollY>8),{passive:true});}
function chips(){document.querySelectorAll('.chip').forEach(c=>c.addEventListener('click',()=>{
  c.closest('.cfilters')?.querySelectorAll('.chip').forEach(x=>x.classList.remove('active'));
  c.classList.add('active');}));}
function countdown(){
  document.querySelectorAll('[data-countdown]').forEach(el=>{
    let s=parseInt(el.dataset.countdown,10)||900;
    (function tick(){
      const m=String(Math.floor(s/60)).padStart(2,'0');
      const sec=String(s%60).padStart(2,'0');
      el.textContent=m+':'+sec;
      if(s>0){s--;setTimeout(tick,1000);}else{el.closest('.urgency')?.remove();}
    })();
  });
}
document.addEventListener('DOMContentLoaded',()=>{
  Drawer.init();
  Cart.get().then(c=>Drawer.count(c.item_count));
  accordions();reveals();stickyAtc();gallery();mobileNav();headerShadow();chips();countdown();
  document.addEventListener('click',e=>{
    const b=e.target.closest('[data-atc]');if(b){e.preventDefault();atc(b);}
    const c=e.target.closest('[data-open-cart]');if(c){e.preventDefault();Drawer.open();}
  });
});
})();
